/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
accordion();

function accordion() {
  const blocks = document.querySelectorAll('.additional-info');
  if (blocks.length > 0) {
    
    blocks.forEach(el => {
      const items = el.querySelectorAll('.accordion-item');
      items.forEach(e => {
        const title = e.querySelector('.title');
        title.addEventListener('click', () => {
          e.classList.toggle('active');
        })
      })
    })
  }
}

window.addEventListener('load', () => {
  const heights = document.querySelectorAll('.product-list--scrollable .product-card')
  if (heights.length > 0) {
    let maxHeight = 0;
    heights.forEach(e => {
      const height = e.clientHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    })
    document.querySelector('.flickity-viewport').style.height = `${maxHeight}px`;
  }
})

/* --- Horizontal tabs --- */

var HorizontalTabs = class extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.tabcontent');
    this.querySelectorAll('.tablink').forEach(el => el.addEventListener('click', this.changeTab.bind(this)));
  }

  connectedCallback() {
    this.querySelector('.tablink')?.click();
  }

  changeTab(event) {
    const buttons = document.querySelectorAll('.tablink');
    const tabId = event.target.getAttribute('open-tab');
    
    buttons.forEach(btn => {
      btn.classList.remove("active");
    })

    this.tabs.forEach(tab => {
      tab.style.display = "none";
    })

    document.getElementById(tabId).style.display = "flex";
    event.currentTarget.classList.add('active');
  }
}

window.customElements.define('h-tabs', HorizontalTabs);

var SidecartRecommendations = class extends HTMLElement {
  /** @type{HTMLDivElement} */ _cartItems;

  constructor() {
    super();

    this._cartItems = document.querySelector('.cart-modal__products');
    
    this.header = document.querySelector('.sidecart-recommendations-header');
    this.recommendationsList = document.querySelector('.recommendations-list');
    document.addEventListener('cart:update:start', this._hide.bind(this));

    document.addEventListener('cart:update', this._cartUpdate.bind(this));
  }

  connectedCallback() {
    this._initiateRender();
  }

  _hide() {
    this.classList.add('dn');
  }

  _cartUpdate() {
    this._initiateRender();
  }
  _initiateRender() {
    const productIds = [];
    this._cartItems.querySelectorAll('.product').forEach(item => productIds.push(item.getAttribute('product-id')));

    if (productIds.length > 0) {
      this.header.innerHTML = "Ga voor nog meer resultaat:";
    } else {
      this.header.innerHTML = "Bekijk onze bestsellers:";
    }

    this._hide();
    Clerk('call', 'recommendations/complementary', {
      limit: 5,
      products: productIds
    }, this._renderItems.bind(this), this._onError.bind(this));
  }

  _renderItems(response) {
    const renderQuery = response.result.map(function (item) {
      return `id:${ item }`;
    }).join(' OR ');

    fetch(`/search?q=${ renderQuery }&section_id=sidecart-recommendations&type=product`, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(response => response.text()).then(text => {
      let htmlObject = document.createElement('div');
      htmlObject.innerHTML = text;

      this.recommendationsList.innerHTML = htmlObject.querySelector('.swiper').parentElement.innerHTML;
      this._initSliderAndEvents();
    }).catch(error => {
      console.log(error);
      this._onError(error);
    });
  }

  _onError(_) {
    this.classList.add("dn");
  }

  _initSliderAndEvents() {
    const swiperElement = this.querySelector('.sidecart-recommendations__item--slider .swiper-container');
    new Swiper(swiperElement, {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      }
    });
    this.classList.remove("dn");
  }
}

window.customElements.define('sidecart-recommendations', SidecartRecommendations);

var LineItemQuantity = class extends HTMLElement {
  constructor() {
    super();

    this._inputElement = this.querySelector('[data-line-key]');
    this._inputElement.addEventListener("click", this._onQuantityChanged.bind(this));

    this._quantitySelector = this.querySelector('quantity-selector');

    const buttons = this.querySelectorAll('[href*="/cart/change"]');

    this._minus = buttons[0];
    this._minus.addEventListener("click", this._onChangeLinkClicked.bind(this));
    
    this._plus = buttons[1];
    this._plus.addEventListener("click", this._onChangeLinkClicked.bind(this));
  }

  _onQuantityChanged(event) {
    this._changeLineItemQuantity(event.target.getAttribute("data-line-key"), parseInt(event.target.value));
  }

  _onChangeLinkClicked(event) {
    event.preventDefault();
    const target = event.target.closest('a');

    if (target.disabled) return;

    const url = new URL(target.href);
    this._changeLineItemQuantity(url.searchParams.get("id"), parseInt(url.searchParams.get("quantity")));
  }

  async _changeLineItemQuantity(lineKey, targetQuantity) {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: targetQuantity
      })
    });

    this._inputElement.value = targetQuantity;

    this._minus.href = this._minus.href.replace(/quantity=\d*/, `quantity=${Math.max(targetQuantity - 1, 1)}`);
    this._plus.href = this._plus.href.replace(/quantity=\d*/, `quantity=${targetQuantity + 1}`);

    this._quantitySelector.updateUi();

    const cartData = await response.json();

    /* update line item price  */
    const linePrice = "€" + (cartData.items.find(item => item.key === lineKey).line_price / 100).toFixed(2);
    const linePriceContainer = this._inputElement.closest('.product').querySelector('.money');

    if (linePriceContainer) {
      linePriceContainer.innerHTML = linePrice;
    }

    /* update final price */
    const price = "€" + (cartData.total_price / 100).toFixed(2);
    const cartPriceContainer = document.querySelector('[data-cart-modal-total-price]');

    if (cartPriceContainer) {
      cartPriceContainer.innerHTML = price;
    }

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  }
};

if (!window.customElements.get("line-item-quantity")) {
  window.customElements.define("line-item-quantity", LineItemQuantity);
}

var QuantitySelector = class extends HTMLElement {
  constructor() {
    super(...arguments);
    
    this._decreaseButton = null;
    this._increaseButton = null;
    this._inputElement = null;
  }

  connectedCallback() {
    this._decreaseButton = this.querySelector(".quantity-selector__button:first-of-type");
    this._increaseButton = this.querySelector(".quantity-selector__button:last-of-type");
    this._inputElement = this.querySelector("input");

    this._decreaseButton?.addEventListener("click", this._onDecreaseQuantity.bind(this));
    this._increaseButton?.addEventListener("click", this._onIncreaseQuantity.bind(this));

    this.updateUi();
  }

  _onDecreaseQuantity() {
    this.updateUi();
  }

  _onIncreaseQuantity() {
    this.updateUi();
  }

  updateUi() {
    this._decreaseButton.disabled = this._inputElement.value <= 1;
  }
};

var QuantityInput = class extends HTMLInputElement {
  constructor() {
    super();

    this.addEventListener("input", this._onValueInput.bind(this));
    this.addEventListener("focus", this.select);
  }

  connectedCallback() {
    this.style.setProperty("--quantity-selector-character-count", `${this.value.length}ch`);
  }

  get quantity() {
    return parseInt(this.value);
  }

  _onValueInput() {
    if (this.value === "") {
      this.value = this.min || 1;
    }
    this.style.setProperty("--quantity-selector-character-count", `${this.value.length}ch`);
  }
};

if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}
if (!window.customElements.get("quantity-input")) {
  window.customElements.define("quantity-input", QuantityInput, { extends: "input" });
}